import React from 'react'
import { Form, Select } from 'antd'
import { FRAMEWORK_TYPES, getFrameworkName } from '../../../../../../../../constants/framework-types'
import { useSelector } from 'react-redux'
import Access from '../../../../../../components/access/Access'
import { AssignmentPermissions } from '../../../../../../../../constants/assignment-permissions'
import Text from 'antd/es/typography/Text'

const TestFramework = ({ initialValue, setFramework }) => {
    const language = useSelector(state => state.assignment.assignment.language)

    const options = FRAMEWORK_TYPES.reduce((acc, frameworkType) => {
        if (frameworkType.languages.includes(language)) {
            acc.push({
                value: frameworkType.value,
                label: frameworkType.name,
            })
        }
        return acc
    }, [])

    return (
        <Form.Item
            label='Framework'
            name='framework'
            rules={[{ required: true, message: 'Please, select framework to be used' }]}
        >
            <Access
                permissions={[AssignmentPermissions.CAN_EDIT]}
                fallback={<Text>{getFrameworkName(initialValue)}</Text>}
            >
                <Select
                    placeholder='Please, select framework to be used'
                    notFoundContent='There are no frameworks for that language'
                    onChange={value => setFramework(value)}
                    options={options}
                    showSearch
                    popupMatchSelectWidth={false}
                    getPopupContainer={triggerNode => triggerNode.parentNode}
                    optionFilterProp='label'
                />
            </Access>
        </Form.Item>
    )
}

export default TestFramework
